/**
 * Single source of truth for backend base URL.
 * Prefer runtime window.env (e.g. from env.js) then build-time REACT_APP_API_URL.
 */
export function getBaseUrl() {
  const fromWindow =
    typeof window !== "undefined" && window.env && window.env.API_URL;
  const fromProcess = process.env.REACT_APP_API_URL || process.env.API_URL;
  return fromWindow || fromProcess || "";
}
